export default __webpack_public_path__ + "static/media/Townhall.6b6e1b55.png";